export const FILE_LACKS_ALL_KEYS = 'FILE_LACKS_ALL_KEYS'
export const FILE_HAS_DUPLICATED_CHARACTER_ATTIRBUTES = 'FILE_HAS_DUPLICATED_CHARACTER_ATTIRBUTES'
export const FILE_HAS_NO_CHARACTER_ATTRIBUTES = 'FILE_HAS_NO_CHARACTER_ATTRIBUTES'
export const FILE_LACKS_CHARACTER_ATTRIBUTE_METADATA = 'FILE_LACKS_CHARACTER_ATTRIBUTE_METADATA'
export const FILE_CONTAINS_INVALID_CHARACTER_ATTRIBUTE_METADATA =
  'FILE_CONTAINS_INVALID_CHARACTER_ATTRIBUTE_METADATA'
export const FILE_CONTAINS_INVALID_CHARACTER_ATTRIBUTE_VALUES =
  'FILE_CONTAINS_INVALID_CHARACTER_ATTRIBUTE_VALUES'
